module.exports = __webpack_public_path__ + "img/marilia.f3c1cce9.jpeg";